<div class="thankyouScreen">
<div class="modal-content thankyou">
      <div class="content">
        <figure>
          <img src="../../../../assets/images/tick_icon.gif" alt="git icon"/>
        </figure>
        <p class="ft-wt">Thankyou!</p>
        <p>Your payment is successful</p>
      </div>
  </div>
  </div>